import React from "react";
import PageSurfaceHeader from "./PageSurfaceHeader.jsx";
import "./WorkspacePageHeader.css";
import { joinClasses } from "./resultsPrimitives/shared.js";

// Opt-in header for workspace pages; the Dispatch chrome keeps its own presentation.
export default function WorkspacePageHeader({
  icon: Icon,
  children = null,
  className = "",
  actionsClassName = "",
  truckBanner = false,
  ...headerProps
}) {
  return (
    <section
      className={joinClasses([
        "grid min-w-0 gap-3 rounded-[4px] border border-line-soft border-t-2 border-t-accent bg-white p-3 shadow-sm",
        truckBanner && "workspace-truck-banner",
        className,
      ])}
      data-workspace-page-header="true"
    >
      <PageSurfaceHeader
        titleAs={truckBanner ? "h1" : "h2"}
        {...headerProps}
        className="gap-3"
        copyClassName="min-w-0 max-w-full flex-[1_1_20rem]"
        titleClassName="min-w-0 break-words text-xl sm:text-2xl"
        titleRowClassName="flex-nowrap"
        descriptionClassName="mt-1 text-[13px] leading-5"
        eyebrowClassName="mb-1 text-[10px] tracking-[0.14em]"
        actionsClassName={joinClasses(["min-w-0 max-w-full items-center", actionsClassName])}
        titlePrefix={Icon ? (
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[4px] bg-accent text-white" aria-hidden="true">
            <Icon size={19} />
          </span>
        ) : null}
      />
      {children ? <div className="min-w-0 border-t border-line-soft pt-3">{children}</div> : null}
    </section>
  );
}
